class CampaignService {
    static getStatusId(status) {
        switch(status){
            case "ACTIVE": return 1;
            case "DRAFT": return 2;
            case "CANCELED": return 3;
            case "COMPLETED": return 4;
            case "ARCHIVED": return 5;
            default: return 6;
        }
    };

    static getObjectiveTypeId(objectiveType) {
        switch(objectiveType) {
            case "BRAND_AWARENESS": return 1;
            case "ENGAGEMENT": return 2;
            case "JOB_APPLICANT": return 3;
            case "LEAD_GENERATION": return 4;
            case "VIDEO_VIEW": return 5;
            case "WEBSITE_CONVERSION": return 6;
            default: return 7;
        }
    }

}

export default CampaignService